import { pendingTask, begin } from 'react-redux-spinner'
import api from "../api";
import { handleApiError } from "../lib/helper";

function loadRequest() {
  return {
    type: 'FETCH_REQUEST',
    [pendingTask]: begin
  }
}

export function initSuccess(data) {
  return {
    type: 'INITIALIZE',
    payload: data
  }
}

export function setProductKey(productKey) {
  return {
    type: 'SET_PRODUCT_KEY',
    productKey: productKey
  }
}

export function init() {
  return dispatch => {
    dispatch(loadRequest());
    return api.init()
      .then(res => {
        dispatch(initSuccess(res.data))
        localStorage.setItem("rezydent", res.data.login);
      })
      .catch(handleApiError, 'init error');
  }
}
